import React, { useCallback } from 'react';
import { AppView, SCREEN_BOTTOM_PADDING, withAnimatedNavigationHeader, } from 'design-system';
import TransactionsPreview from 'features/transactions/components/TransactionsPreview';
import { getTransactionsForSchedule } from 'actions';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { isWeb } from '../../../constants';
const ScheduledTransactionListScreen = withAnimatedNavigationHeader(({ route, scrollHandler }) => {
    const { scheduleId, transactionIds, accountId, initialTransactions } = route.params;
    const accountIdsStr = `accountIds[]=${accountId}`;
    const endpoint = useCallback((_, page) => getTransactionsForSchedule({ scheduleId, transactionIds, accountIdsStr }, page), [scheduleId, transactionIds, accountIdsStr]);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const paddingBottom = useMarginBottom('paddingBottom', SCREEN_BOTTOM_PADDING, paddingHorizontalStyle);
    return (<AppView withFrame={false}>
          <TransactionsPreview onScroll={scrollHandler} contentContainerStyle={paddingBottom} endpoint={endpoint} initialTransactions={initialTransactions}/>
        </AppView>);
}, ({ colors }) => ({
    title: 'Created transactions',
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
export default ScheduledTransactionListScreen;
